import styled from 'styled-components';
import { SPACES } from 'common/constants/sizes';

export const StyledTopBar = styled.div`
  height: 8rem;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  padding-left: ${SPACES.medium};
  background-color: white;
  z-index: 1400;
`;

export const StyledLogoWrapper = styled.div`
  height: 100%;
  justify-content: center;
  padding-right: ${SPACES.medium};
`;

export const StyledLogo = styled.img`
  height: 100%;
  width: 14rem;
`;
